function updateVariantDescription(variantId) {
  // Get the currently visible description
  const currentlyVisible = document.querySelector('.variant-description[style*="block"]');
  const targetEl = document.querySelector(`.variant-description[data-variant-id="${variantId}"]`);
  
  // If target element doesn't exist, hide all and return
  if (!targetEl) {
    document.querySelectorAll('.variant-description').forEach(el => {
      el.style.display = 'none';
    });
    return;
  }
  
  // Check if the content is identical (requirement #1)
  if (currentlyVisible && currentlyVisible !== targetEl) {
    const currentContent = currentlyVisible.innerHTML.trim();
    const targetContent = targetEl.innerHTML.trim();
    
    // If content is identical, don't change anything
    if (currentContent === targetContent) {
      return;
    }
    
    // Stop any playing media in the currently visible description (requirement #2)
    stopMediaInElement(currentlyVisible);
  }
  
  // Hide all descriptions
  document.querySelectorAll('.variant-description').forEach(el => {
    el.style.display = 'none';
  });
  
  // Show the target description
  targetEl.style.display = 'block';
}

// Stop all media (videos, audio) in a given element
function stopMediaInElement(element) {
  // Stop HTML5 videos
  const videos = element.querySelectorAll('video');
  videos.forEach(video => {
    video.pause();
    video.currentTime = 0;
  });
  
  // Stop HTML5 audio
  const audios = element.querySelectorAll('audio');
  audios.forEach(audio => {
    audio.pause();
    audio.currentTime = 0;
  });
  
  // For iframes (YouTube, Vimeo, etc.), we'll use a different approach
  // Instead of reloading or using postMessage (which can cause history issues),
  // we'll clone and replace the iframe, which removes it from the DOM and stops playback
  const iframes = element.querySelectorAll('iframe');
  iframes.forEach(iframe => {
    // Clone the iframe (creates a fresh copy that's not playing)
    const clone = iframe.cloneNode(true);
    // Replace the original with the clone
    iframe.parentNode.replaceChild(clone, iframe);
  });
}

// Get initial variant ID (URL param first, then form input, then first variant)
function getCurrentVariantId() {
  const urlParams = new URLSearchParams(window.location.search);
  let variantId = urlParams.get('variant');

  if (!variantId) {
    const variantInput = document.querySelector('select[name="id"], input[name="id"]');
    if (variantInput && variantInput.value) {
      variantId = variantInput.value;
    } else {
      // If no variant input or value, check if there are any variants on the page
      const firstVariantEl = document.querySelector('.variant-description[data-variant-id]:not([data-variant-id="fallback"])');
      variantId = firstVariantEl ? firstVariantEl.getAttribute('data-variant-id') : null;
    }
  }

  return variantId;
}

// Initial update after slight delay to allow variant-selects to initialize
setTimeout(() => {
  const initialVariantId = getCurrentVariantId();
  updateVariantDescription(initialVariantId);
}, 100);

document.addEventListener('DOMContentLoaded', () => {
  const variantInput = document.querySelector('select[name="id"], input[name="id"]');
  if (variantInput) {
    variantInput.addEventListener('change', (e) => updateVariantDescription(e.target.value));
  }
  document.addEventListener('product:variant-change', (e) => {
    if (e.detail && e.detail.variant && e.detail.variant.id) {
      updateVariantDescription(e.detail.variant.id);
    }
  });
});